import { signal } from '@preact/signals-react'

/**
 * Минимальный набор глобальных сигналов для wallet connect
 * Основная логика находится в хуке useWallet
 */

// Промис для синхронизации состояния кошелька при инициализации
let walletSyncResolver: (() => void) | null = null
let walletSyncPromise: Promise<void> = new Promise((resolve) => {
  walletSyncResolver = resolve
})

// Флаг завершения синхронизации
export const isWalletSynced = signal(false)

/**
 * Получить промис синхронизации (для использования в loader/guard)
 */
export const getWalletSyncPromise = () => walletSyncPromise

/**
 * Резолвить промис синхронизации
 */
export const resolveWalletSync = () => {
  if (walletSyncResolver && !isWalletSynced.value) {
    isWalletSynced.value = true
    walletSyncResolver()
    walletSyncResolver = null
  }
}

/**
 * Сбросить промис синхронизации (для переподключения)
 */
export const resetWalletSync = () => {
  isWalletSynced.value = false
  walletSyncPromise = new Promise((resolve) => {
    walletSyncResolver = resolve
  })
}
